import { faEllipsis } from '@fortawesome/pro-regular-svg-icons/faEllipsis';
import React, { useState } from 'react';

import { Box, Flex, Text, useToken } from 'quotient';

import { NavigationItemMenu } from './NavigationItemMenu';
import { NavigationItem, NavigationItemType } from './types';

interface NavigationItemComponentProps {
  item: NavigationItem | NavigationItemType;
  isSelected: boolean;
  onClick: (item: NavigationItem | NavigationItemType) => void;
}

export const NavigationItemComponent: React.FC<NavigationItemComponentProps> = ({ isSelected, item, onClick }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [selectedBgColor, normalTextColor] = useToken('colors', [
    'primary.100', // Selected background
    'primaryNeutral.900', // Normal text
  ]);

  const hasMenuItems = item.menuItems && item.menuItems.length > 0;

  return (
    <Box key={item.id}>
      <Box
        _focus={{
          outline: 'none',
          bg: isSelected ? selectedBgColor : 'primaryNeutral.200',
        }}
        _hover={{
          bg: isSelected ? selectedBgColor : 'primaryNeutral.100',
        }}
        as="button"
        bg={isSelected ? selectedBgColor : 'transparent'}
        border="none"
        borderRadius="md"
        color={normalTextColor}
        cursor="pointer"
        fontSize="14px"
        px={4}
        py={2}
        textAlign="left"
        transition="background-color 0.2s ease"
        w="100%"
        onClick={() => onClick(item)}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <Flex align="center" justify="space-between" w="100%">
          <Flex direction="column">
            <Text textStyle={isSelected ? 'bodySemiBold' : 'bodyRegular'}>{item.title}</Text>
            {item.subtitle && (
              <Text color={isSelected ? 'primaryNeutral.900' : 'primaryNeutral.700'} textStyle="smallRegular">
                {item.subtitle}
              </Text>
            )}
          </Flex>
          {isHovered && hasMenuItems && item.menuItems && (
            <NavigationItemMenu icon={faEllipsis} itemId={item.id} menuItems={item.menuItems} />
          )}
        </Flex>
      </Box>
    </Box>
  );
};
